import { useState } from "react";
import { Info } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { REGOLAMENTI } from "@/constants/regolamenti";

export function RegolamentoModal({ game }) {
  const [open, setOpen] = useState(false);
  const r = REGOLAMENTI[game];
  if (!r) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid={`regolamento-btn-${game}`}
          title="Regolamento"
          className="shrink-0 inline-flex items-center gap-1.5 rounded-md border px-2.5 py-2 text-xs font-bold transition-colors hover:bg-white/10"
          style={{ borderColor: r.color + "66", color: r.color }}
        >
          <Info size={16} /> Regolamento
        </button>
      </DialogTrigger>
      <DialogContent
        data-testid={`regolamento-modal-${game}`}
        className="max-w-lg max-h-[85vh] overflow-y-auto bg-[#12161A] border-white/10 text-[#F1F5F9]"
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-extrabold" style={{ color: r.color }}>
            {r.title}
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-[#94A3B8]">{r.intro}</p>

        <div className="mt-2 space-y-4">
          {r.sections.map((s, i) => (
            <div key={i} data-testid={`regolamento-section-${game}-${i}`}>
              <h3 className="text-sm font-extrabold uppercase tracking-wide" style={{ color: r.color }}>
                {s.heading}
              </h3>
              <ul className="mt-1.5 space-y-1.5">
                {s.items.map((it, j) => (
                  <li key={j} className="flex gap-2 text-sm text-[#E2E8F0]">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: r.color }} />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {r.footer && (
          <div className="mt-3 rounded-lg border p-3 text-sm font-bold" style={{ borderColor: r.color + "40", backgroundColor: r.color + "12", color: r.color }}>
            {r.footer}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
